import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type CircleDollarProps = {
    className?: string;
};

const CircleDollar: FunctionComponent<CircleDollarProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'circle-dollar'}
            viewBox="0 0 250 250"
        >
            <path d="M125.4 0C56.3 0 .2 56.1.2 125.2s56.2 125.2 125.2 125.2c69.1 0 125.2-56.1 125.2-125.1C250.6 56.2 194.5 0 125.4 0zm0 241.4c-64.1 0-116.2-52.1-116.2-116.2S61.3 9 125.4 9s116.2 52.2 116.2 116.3c0 64-52.1 116.1-116.2 116.1z" />
            <path d="M148.2 123.9c-3.7-2.3-7.7-4.2-12.1-5.8-4.3-1.6-8.3-3.1-12.1-4.6s-6.8-3-9.3-4.7c-2.5-1.6-3.7-3.7-3.7-6.2 0-3.3 1.3-5.8 3.9-7.7 2.6-1.9 6.2-2.8 10.7-2.8 5 0 9.3.8 12.7 2.3 3.4 1.5 7.1 3.7 10.9 6.6l9.5-11c-3.4-3.4-7.1-6.2-11.2-8.5s-9-3.8-14.8-4.4V55.7h-13.1v21.5c-8.2 1.1-14.7 3.9-19.5 8.4-4.8 4.5-7.2 10.3-7.2 17.4 0 4.9 1.2 9 3.7 12.2 2.5 3.2 5.5 6 9.3 8.3s7.7 4.2 12 5.8c4.3 1.6 8.3 3.2 12 4.8 3.7 1.6 6.8 3.3 9.3 5.2 2.5 1.9 3.7 4.2 3.7 7.1 0 3.3-1.3 5.9-4 7.9s-6.6 3-11.9 3c-5.7 0-10.9-1-15.7-3-4.8-2-9.6-4.5-14.3-7.7l-8.5 13c4 3.4 8.9 6.3 14.4 8.6 5.6 2.4 11.2 3.8 16.9 4.3v23.8h13.1V172c9-1.3 15.9-4.4 20.9-9.3 5-4.9 7.5-10.8 7.5-17.8 0-5-1.2-9.2-3.7-12.5-2.6-3.4-5.7-6.2-9.4-8.5z" />
        </svg>
    );
};
export default CircleDollar;
